import React, { useEffect } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IResDashboard, UnsuccessfulCollections } from '@/types/parcel/dashboard';

import { useDate } from '../Context/DateContext';

interface StateData {
  data: UnsuccessfulCollections['collections'] | null;
  isLoading: boolean;
  isError: boolean;
}

const useUnsuccessfulPickups = () => {
  const { selectedDate } = useDate();
  const [data, setData] = React.useState<StateData>({
    data: null,
    isLoading: true,
    isError: false,
  });
  const getUnsuccessfulCollections = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.dashboard.unsuccessfulCollections(selectedDate);

      setData({
        data: (response as IResDashboard<UnsuccessfulCollections>).data.collections,
        isLoading: false,
        isError: false,
      });
    } catch {
      setData({ data: null, isLoading: false, isError: true });
    }
  };

  useEffect(() => {
    getUnsuccessfulCollections();
  }, [selectedDate]);

  return {
    data,
  };
};

export default useUnsuccessfulPickups;
